import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Item from './Components/Item';

const HookOfferItems = (props) => {
	const { t, i18n } = useTranslation();

	const [offerData, setOfferData] = useState({
		one_offer_display: false,
		items: [],
		user_data: {}
	});
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		console.log('offerData', offerData);
	}, [offerData]);

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);

		loadData();
	}, []);

	async function loadData() {
		try {
			const response = await axios.get(`/HookOfferItems/ajaxLoadFrontendData/${props.hook_id}/${props.curlang}`);

			setOfferData(response.data);

			if (response.data.user_data) {
				setOfferData(prevData => ({
					...prevData,
					user_data: response.data.user_data
				}));
			}

			setLoaded(true);
		} catch (e) {
			// If API fails, set default data to prevent infinite loading
			setLoaded(true);
		}
	}

	if (loaded) {
		const items = Array.isArray(offerData.items) ? offerData.items : [];
		const defaultItem = items.find((item) => item.remaining !== 0) || items[0] || null;
		const hidePicker = !!offerData.gamification || (!offerData.one_offer_display && items.length === 1);

		if (hidePicker) {
			if (!defaultItem) {
				return (
					<input type="hidden" id="hidden-offer-item-select" />
				);
			}
			return (
				<input type="hidden" name="page_user_hook_offer_item[hook_offer_item_id]" id="hidden-offer-item-select" value={defaultItem._id} />
			);
		}
		if (items.length === 0) {
			return null;
		}
		return (
			<>
			<span className="mb-2 d-block fs-7 text-muted px-4">{t('請選擇優惠')}</span>
			<div className="col-12 offer mb-5 px-4">
				<fieldset className="offer_choice session_choice form-group fv-plugins-icon-container">
					{(() => {
						const components = [];

						items.map(function(item, index) {
							components.push(
								<Item
									key={`offer-item-${index}`}
									hook_id={props.hook_id}
									item={item}
									index={index}
									offerData={offerData}
								/>
							);
						})

						return components;
					})()}
				</fieldset>
			</div>
			</>
		);
	}
}

export default HookOfferItems;